<!--
 * @Description: 首页·mobile 第三个模块 （海量内容 正版授权 & 经典故事孩子都爱）
 * @Author: xiehuaqiang
 * @FilePath: /kada-official-web/public/mobile/src/views/home/BookNumberDesc.vue
 * @Date: 2020-12-18 11:43:03
-->
<template>
    <div class='module-cont module-statistic' :style="whiteBg ? 'background: white': ''">
        <img :src="imgSrc" alt="" srcset="">
        <!-- <div class="top-module-cont">
            <h1>KaDa阅读馆藏内容</h1>
            <div class="title-cont set-margin">
                <h3>海量内容 正版授权</h3>
                <p>让阅读更有营养</p>
            </div>
            <div class="line-cont flex-cont">
                <div v-for="(item, index) in firstLineData" :key="index" class="item-cont">
                    <div class="count">{{item.count}}</div>
                    <div class="desc">{{item.desc}}</div>
                </div>
            </div>
            <div class="line-cont flex-cont">
                <div v-for="(item, index) in secondLineData" :key="index" class="item-cont">
                    <div class="count">{{item.count}}</div>
                    <div class="desc">{{item.desc}}</div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
    export default {
        props: {
            imgSrc: {
                type: String,
                default: '//cdn.hhdd.com/frontend/as/i/603ae87e-50b7-569d-9137-ab45bd5b97c9.png'
            },
            whiteBg: {
                type: Boolean,
                default: false
            }
        },
        components:{},
        data() {
            return {
                firstLineData: [
                    { count: '10000+', desc: '互动绘本' },
                    { count: '20000+', desc: '有声故事' },
                    { count: '15000+', desc: '知识轻课' },
                    { count: '4000+', desc: '经典图书' },
                ],
                secondLineData: [
                    { count: '300+', desc: '内容机构合作' },
                    { count: '600+', desc: '主题内容覆盖' },
                    { count: '116+', desc: '童书大奖覆盖' },
                    { count: '120+', desc: '全球名家荟萃' },
                ],
            }
        },
    }
</script>

<style lang='stylus' scoped>
@import "../../style/vui/mixins"
.module-statistic
    padding-top px2rem2(36)
    background-color #F6F8FB
    // .set-margin
    //     p
    //         margin-bottom px2rem2(30)
    // .title-cont
    //     padding-top px2rem2(39)
    //     text-align center
    //     color #ffffff
    //     h3
    //         font-size px2rem2(20)
    //         font-weight 600
    //         height px2rem2(28)
    //         line-height px2rem2(28)
    //         margin-bottom px2rem2(6)
    //     p
    //         font-size px2rem2(12)
    //         height px2rem2(17)
    //         line-height  px2rem2(17)
    // .top-module-cont
    //     background-image url(//cdn.hhdd.com/frontend/as/i/a0701baa-d995-5b96-b944-fb85c3d000ee.png)
    //     background-size 100% 100%
    //     background-repeat no-repeat
    //     background-position center top
    //     height px2rem2(270)
    //     .flex-cont
    //         display flex
    //         justify-content center
    //     .line-cont
    //         margin-bottom px2rem2(20)
    //         .item-cont
    //             color #ffffff
    //             text-align center
    //             width px2rem2(80)
    //             .count
    //                 font-weight 600
    //                 height px2rem2(24)
    //                 line-height px2rem2(24)
    //                 font-size px2rem2(16)
    //             .desc
    //                 font-size px2rem2(12)
    //                 height px2rem2(17)
    //                 line-height px2rem2(17)
    //                 opacity .8
    //     .swiper-cont
    //         overflow-scrolling: touch
    //         margin-top px2rem2(20)
    //         .swiper-slide
    //             margin-right px2rem2(10)
    //             img
    //                 width px2rem2(90)
    // .bottom-module-cont
    //     .title-cont
    //         padding-top px2rem2(10)
    //         p
    //             color #666666
    //     .ip-swiper-cont
    //         // .swiper-container
    //         //     margin-left px2rem2(-12)
    //         height px2rem2(170)
    //         overflow-scrolling: touch
    //         margin-top px2rem2(20)
    //         .flex-cont
    //             display flex
    //             justify-content space-evenly
    //             &:first-child
    //                 margin-bottom px2rem2(10)
    //         .swiper-slide
    //             margin-right px2rem2(10)
    //             img
    //                 width px2rem2(68)
</style>



// WEBPACK FOOTER //
// src/views/home/BookNumberDesc.vue